<template>
  <MonitorWrapper class="rms-c">
    <el-row :gutter="20">
      <el-col :span="24">
        <info-block :title="[deviceName, sn]">
          <template #titleRight>
            <span>设备电量：{{ powerPercent }}%</span>
          </template>
          <template #content>
            <el-row class="rms-info state-block">
              <el-col :span="8">
                <ModsIcon
                  showText
                  :alarmState="alarmState"
                  :alarmDic="alarm"
                  width="120px"
                  icon="icon-he"
                  :wsData="wsData"
                  :mods="curMod"
                />
              </el-col>
              <el-col :span="8">
                <div>
                  <span>射线本底数(CPS):</span>
                  <span>{{ bgroundValue }}</span>
                </div>
                <div>
                  <span>射线实时数(CPS):</span>
                  <span>{{ realValue }}</span>
                </div>
                <div>
                  <span>报警状态:</span>
                  <span :style="{ color: alarmColor }">
                    {{ alarmState | alarmText }}
                  </span>
                </div>
              </el-col>
            </el-row>
            <div class="rms-chart" style="overflow: hidden">
              <v-chart :options="leftOp" :autoresize="true"></v-chart>
            </div>
          </template>
        </info-block>
      </el-col>
    </el-row>
  </MonitorWrapper>
</template>

<script>
import { mapState } from 'vuex';
import InfoBlock from '../components/info-block';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';
import ModsIcon from '@/components/mods-icon';
import monitorMixin from '@/mixins/monitorMixin';

export default {
  name: 'RMS-C',
  components: {
    InfoBlock,
    ModsIcon
  },
  mixins: [monitorMixin],
  filters: {
    alarmText(state) {
      const dict = ['正常', '数值报警', '电量报警', '故障报警'];
      return dict[state] || '';
    }
  },
  data() {
    return {
      alarm: ['正常', '数值报警', '电量报警', '故障报警'],
      ciaeRms: null,
      leftOp: lineAreaStyle({
        legend: {
          right: 10,
          orient: 'vertical',
          align: 'left',
          icon: 'rect',
          textStyle: {
            color: '#fff'
          }
        },
        yAxis: { name: 'CPS' },
        color: ['#06c9c3', '#7a17c7'],
        series: [
          {
            name: '射线本底数',
            areaStyle: { color: graColor('rgba(6, 201, 195, .8)', 'rgba(6, 201, 195, 0.1)') }
          },
          {
            name: '射线实时数',
            type: 'line',
            symbolSize: 10,
            smooth: true,
            data: [],
            areaStyle: { color: graColor('rgba(122, 23, 199, .8)', 'rgba(122, 23, 199, 0.1)') }
          }
        ]
      }),
      wsData: {},
      curMod: 'nuclearMod'
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData', 'historyDetailDatas']),
    alarmState() {
      return this.ciaeRms ? this.ciaeRms.alarmState : 0;
    },
    powerPercent() {
      return this.ciaeRms ? this.ciaeRms.powerPercent : 0;
    },
    alarmColor() {
      return this.alarmState !== 0 ? '#FF4847' : '#03b36e';
    },
    realValue() {
      return this.ciaeRms ? this.ciaeRms.realValue : 0;
    },
    bgroundValue() {
      return this.ciaeRms ? this.ciaeRms.bgroundValue : 0;
    },
    deviceName() {
      return this.deviceSNMap[this.sn].name;
    }
  },
  methods: {
    updateData(newVal) {
      const { beginTime } = newVal;
      const { ciaeRms } = newVal.mods[this.curMod];
      this.ciaeRms = ciaeRms;
      this.wsData = newVal;
      this.leftOp.series[0].data.push([beginTime, ciaeRms.bgroundValue]);
      this.leftOp.series[1].data.push([beginTime, ciaeRms.realValue]);
      if (this.leftOp.series[0].data.length > 20) {
        this.leftOp.series[0].data.shift();
        this.leftOp.series[1].data.shift();
      }
    },
    async initPage() {
      if (this.isHisDetail) {
        await this.getHistoryDetailData(this.eventId);
        this.historyDetailDatas.slice(-20).forEach(val => {
          this.updateData(val);
        });
        this.wsData = this.historyDetailData;
        this.ciaeRms = this.historyDetailData.mods[this.curMod].ciaeRms;
        this.hideLoading();
      }
    }
  },
  created() {
    this.initPage();
  }
};
</script>

<style lang="scss" scoped>
.rms-c {
  height: 100%;
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      .rms-info {
        height: 35%;
        &.state-block {
          .el-col {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            &:nth-child(2),
            &:nth-child(3) {
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              font-size: 18px;
              line-height: 34px;
            }
          }
        }
      }
      .rms-chart {
        height: 65%;
      }
    }
  }
  .state {
    @include state-textstyle;
  }
}
</style>
